import React, {useContext} from "react";
import {BrowserRouter as Router, Switch, Route, Redirect} from "react-router-dom";
import RoutesList from "../constants/RouterList";
import MainContainer from "../containers/MainContainer";
import {AuthContext} from "../context/AuthProvider";
import Login from "../views/login/Login";
import FacilitatorsProvider, {FacilitatorsContext} from "../context/FacilitatorsProvider";
import PrimeProvider from "../context/PrimeProvider";
import AcademyProvider from "../context/AcademyProvider";
import EssentialProvider from "../context/EssentialProvider";

export default function Routes() {
   const {isLogin} = useContext(AuthContext);

   if (!isLogin) return <Login />;
   return (
      <FacilitatorsProvider>
         <AcademyProvider>
            <PrimeProvider>
               <EssentialProvider>
                  <Router>
                     <Switch>
                        {RoutesList.map((item, index) => {
                           const theme = {...defaultTheme, back: item.back};
                           return (
                              <Route exact={item.exact} path={item.path} key={index}>
                                 <MainContainer theme={theme} title={item.title}>
                                    <item.component theme={theme} />
                                 </MainContainer>
                              </Route>
                           );
                        })}
                        <Redirect to="/home" />
                     </Switch>
                  </Router>
               </EssentialProvider>
            </PrimeProvider>
         </AcademyProvider>
      </FacilitatorsProvider>
   );
}

const defaultTheme = {
   color: "white",
   back: "#536a82",
   titleSize: "1.6em",
   subtitleSize: "1.3em",
};
